export const AnonymousMapUsername = 'alltrails-guest-maps';
export const PaymentDisplayText = 'AllTrails+';

export const appleConstants = {
  AUTHORIZE_URL: 'https://appleid.apple.com/auth/authorize',
  AUTHORIZE_PARAMS: '?response_type=code%20id_token&response_mode=form_post',
  CLIENT_ID: 'com.alltrails.AllTrails.web',
  SCOPES: 'name email'
};
